import {
  Container,
  SpaceBetween,
  ColumnLayout,
  FormField,
  Input,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { getDisplayContractRoute, getDisplayContractService } from "./util";

interface IExaminationInfo {
  examinationApplicationNo: string;
  applicationNo: number;
  applicationDate: string;
  applicationManager: string;
  updateDifferential: string;
  isStore: boolean;
  registerName: string;
  companyName: string;
  corporateNumber: string;
  merchantName: string;
  contractService: string;
  contractRoute?: string;
}

/**
 * 申請情報
 */
const ExaminationInfo = (props: IExaminationInfo) => {
  const {
    examinationApplicationNo,
    applicationNo,
    applicationDate,
    applicationManager,
    updateDifferential,
    isStore,
    registerName,
    companyName,
    corporateNumber,
    merchantName,
    contractService,
    contractRoute,
  } = props;

  return (
    <Container>
      <SpaceBetween direction={"vertical"} size={"l"}>
        <ColumnLayout columns={5}>
          <FormField label={LABELS.EXAMINATION_APPLICATION_NO}>
            <Input value={examinationApplicationNo} readOnly />
          </FormField>
          <FormField label={LABELS.APPLICATION_NO}>
            <Input
              value={applicationNo === -1 ? "" : applicationNo.toString()}
              readOnly
            />
          </FormField>
          <FormField label={LABELS.APPLICATION_DATE}>
            <Input value={applicationDate} readOnly />
          </FormField>
          <FormField label={LABELS.APPLICATION_MANAGER}>
            <Input value={applicationManager} readOnly />
          </FormField>
          <FormField label={LABELS.APPLICATION_TYPE}>
            <Input value={updateDifferential} readOnly />
          </FormField>
        </ColumnLayout>
        {isStore && (
          <ColumnLayout columns={1}>
            <FormField label={LABELS.REGISTER_NAME}>
              <Input value={registerName} readOnly />
            </FormField>
          </ColumnLayout>
        )}
        <ColumnLayout columns={1}>
          <FormField label={LABELS.COMPANY}>
            <Input value={companyName} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={8}>
          <FormField label={LABELS.CORPORATE_NUMBER}>
            <Input value={corporateNumber} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={1}>
          <FormField label={LABELS.GROUP_NAME}>
            <Input value={merchantName} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={3}>
          <FormField label={LABELS.CONTRACT_SERVICE}>
            <Input
              value={getDisplayContractService(contractService)}
              readOnly
            />
          </FormField>
          <FormField label={LABELS.CONTRACT_ROUTE}>
            <Input value={getDisplayContractRoute(contractRoute)} readOnly />
          </FormField>
        </ColumnLayout>
      </SpaceBetween>
    </Container>
  );
};

export default ExaminationInfo;
